import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { ServiceBookingsState } from 'store/serviceBookings/types';

export const INITIAL_STATE: ServiceBookingsState = {
  mineServiceBookings: null,
  getMineServiceBookings: {
    status: null,
    error: null,
  },
  patchServiceBookingStatus: {
    status: null,
    error: null,
  },
  postServiceBooking: {
    status: null,
    error: null,
  },
};

const getMineServiceBookingsRequestHandler = (state: ServiceBookingsState): ServiceBookingsState => ({
  ...state,
  getMineServiceBookings: {
    status: ACTION_STATUSES.PENDING,
    error: null,
  },
});

const getMineServiceBookingsSuccessHandler = (
  state: ServiceBookingsState,
  { payload }: ActionType<typeof actions.getMineServiceBookings.success>,
): ServiceBookingsState => ({
  ...state,
  mineServiceBookings: payload,
  getMineServiceBookings: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const getMineServiceBookingsFailureHandler = (
  state: ServiceBookingsState,
  { payload }: ActionType<typeof actions.getMineServiceBookings.failure>,
): ServiceBookingsState => ({
  ...state,
  getMineServiceBookings: {
    status: ACTION_STATUSES.REJECTED,
    error: payload.error,
  },
});

const patchServiceBookingStatusRequestHandler = (state: ServiceBookingsState): ServiceBookingsState => ({
  ...state,
  patchServiceBookingStatus: {
    status: ACTION_STATUSES.PENDING,
    error: null,
  },
});

const patchServiceBookingStatusSuccessHandler = (state: ServiceBookingsState): ServiceBookingsState => ({
  ...state,
  patchServiceBookingStatus: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const patchServiceBookingStatusFailureHandler = (
  state: ServiceBookingsState,
  { payload }: ActionType<typeof actions.patchServiceBookingStatus.failure>,
): ServiceBookingsState => ({
  ...state,
  patchServiceBookingStatus: {
    status: ACTION_STATUSES.REJECTED,
    error: payload.error,
  },
});

const createServiceBookingForWaitlistRequestHandler = (state: ServiceBookingsState): ServiceBookingsState => ({
  ...state,
  postServiceBooking: {
    status: ACTION_STATUSES.PENDING,
    error: null,
  },
});

const createServiceBookingForWaitlistSuccessHandler = (
  state: ServiceBookingsState,
  { payload }: ActionType<typeof actions.createServiceBookingForWaitlist.success>,
): ServiceBookingsState => ({
  ...state,
  mineServiceBookings: [...(state.mineServiceBookings || []), payload],
  postServiceBooking: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const createServiceBookingForWaitlistFailureHandler = (
  state: ServiceBookingsState,
  { payload }: ActionType<typeof actions.createServiceBookingForWaitlist.failure>,
): ServiceBookingsState => ({
  ...state,
  postServiceBooking: {
    status: ACTION_STATUSES.REJECTED,
    error: payload.error,
  },
});

const resetPatchServiceBookingStatusHandler = (state: ServiceBookingsState): ServiceBookingsState => ({
  ...state,
  patchServiceBookingStatus: {
    status: null,
    error: null,
  },
});

const ServiceBookingsReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.getMineServiceBookings.request, getMineServiceBookingsRequestHandler)
  .handleAction(actions.getMineServiceBookings.success, getMineServiceBookingsSuccessHandler)
  .handleAction(actions.getMineServiceBookings.failure, getMineServiceBookingsFailureHandler)
  .handleAction(actions.patchServiceBookingStatus.request, patchServiceBookingStatusRequestHandler)
  .handleAction(actions.patchServiceBookingStatus.success, patchServiceBookingStatusSuccessHandler)
  .handleAction(actions.patchServiceBookingStatus.failure, patchServiceBookingStatusFailureHandler)
  .handleAction(actions.createServiceBookingForWaitlist.request, createServiceBookingForWaitlistRequestHandler)
  .handleAction(actions.createServiceBookingForWaitlist.success, createServiceBookingForWaitlistSuccessHandler)
  .handleAction(actions.createServiceBookingForWaitlist.failure, createServiceBookingForWaitlistFailureHandler)
  .handleAction(actions.resetPatchServiceBookingStatus, resetPatchServiceBookingStatusHandler);

export default ServiceBookingsReducer;
